/**
 * Forge turn continuity (decision Forge FDE, 01/10/2026, lot F0). Shared by the
 * worker and the page so both agree on when a turn is still running.
 */

/** The worker running an open turn beats this often. */
export const FORGE_TURN_HEARTBEAT_MS = 3_000;

/** Liveness, not a duration limit: a turn without a beat for this long is no
 * longer running (worker restarted or crashed). A running turn has no cap. */
export const FORGE_TURN_STALE_MS = 20_000;

/** Quality targets of the decision, never limits: a slower turn is reported to
 * us, nothing is cut. A turn that builds the tool is the « assemblage » step. */
export const FORGE_TURN_TARGET_MS = {
  conversation: 30_000,
  assembly: 120_000,
} as const;

/** Whether the open turn's worker is still beating at `now`. The beat may be
 * left by a previous turn, so the turn's own opening also counts as a beat. */
export const isForgeTurnAlive = (params: {
  heartbeatAt: string | null | undefined;
  openedAt: string;
  now?: number;
}): boolean => {
  const now = params.now ?? Date.now();
  const opened = Date.parse(params.openedAt);
  const beat = params.heartbeatAt ? Date.parse(params.heartbeatAt) : Number.NaN;
  const reference = Math.max(
    Number.isFinite(opened) ? opened : Number.NEGATIVE_INFINITY,
    Number.isFinite(beat) ? beat : Number.NEGATIVE_INFINITY,
  );
  if (!Number.isFinite(reference)) return true;
  return now - reference <= FORGE_TURN_STALE_MS;
};
